import {
  CapitalFormationSnapshotDownloadDocument,
  CapitalFormationSnapshotsPaginatedDocument,
} from "api/generated";
import { RequestTypes } from "api/services/enums";
import { getRequestInstance } from "api/services/utils";
import { Optional } from "config";

import {
  ICapitalFormationSnapshotsListVars,
  ICapitalFormationSnapshotListReturnType,
} from "./types";

export async function getCapitalFormationSnapshotsList(
  variables: ICapitalFormationSnapshotsListVars
): Promise<ICapitalFormationSnapshotListReturnType> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.QUERY);
    const res = await makeRequest({
      query: CapitalFormationSnapshotsPaginatedDocument,
      variables,
      fetchPolicy: "network-only",
    });

    return res?.data?.capitalFormationSnapshotsPaginated;
  } catch (error) {
    throw error;
  }
}

export async function downloadCapitalFormationSnapshotDocument(
  id: number
): Promise<Optional<string>> {
  try {
    const makeRequest = getRequestInstance(RequestTypes.MUTATE);
    const res = await makeRequest({
      mutation: CapitalFormationSnapshotDownloadDocument,
      variables: {
        id,
      },
      fetchPolicy: "no-cache",
    });

    return res?.data?.capitalFormationSnapshotDownload;
  } catch (error) {
    throw error;
  }
}
